import Vue from 'vue'
import xss from 'xss'
// import { fetchPost } from '../utils/axiosfunc'

Vue.prototype.xss = xss

const StringUtil = {
  // 是否为空判断
  getOpenId: function (sel, redirectUri, state, code, mobileOpenId) {
    // 测试
    // sel.$cookies.set('openid', 'oog86t9U0JCA6z953CfKHRFGs1lI', '30d')
    // sel.$cookies.set('openid', 'o58621CsDtO7zMdHfiKDrYuKPq5Q', '30d')

    // 正式
    if (mobileOpenId == null || mobileOpenId === '') {
      const url = 'http://service.wisewater.com.cn/zsy_mobile' + '/m/oauth.do'
      const destUrl = '?dest_url=' + redirectUri + '&token=' + state
      window.location.href = url + destUrl
    } else {
      const url = redirectUri + '?token=' + state
      sel.$cookies.set('openid', mobileOpenId, '30d')
      window.location.href = url
    }

    // 旧获取openId
    // if (code == null || code === '') {
    //   var appid = ''
    //   const apiUrl = '/client/api/' + state + '/getAppid.do'
    //   const paramsMenu = {
    //     state: state
    //   }
    //   // 获取appid
    //   fetchPost('/mobilebus' + apiUrl, paramsMenu).then(response => {
    //     const data = response.data
    //     if (data.code === 200) {
    //       appid = data.data
    //       var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
    //       url += 'appid=' + appid
    //       url += '&redirect_uri=' + encodeURIComponent(redirectUri)
    //       url += '&response_type=code'
    //       url += '&scope=snsapi_base'
    //       if (state != null) {
    //         url += '&state=' + state
    //       }
    //       url += '#wechat_redirect'
    //       window.location.href = url
    //     }
    //   })
    // } else {
    //   const apiUrl = '/client/api/' + state + '/oauth2.do'
    //   const paramsMenu = {
    //     code: code,
    //     state: state
    //   }
    //   // 菜单
    //   fetchPost('/mobilebus' + apiUrl, paramsMenu).then(response => {
    //     const data = response.data
    //     if (data.code === 200) {
    //       const openId = data.data
    //       sel.$cookies.set('openid', openId, '30d')
    //       window.location.href = redirectUri
    //     } else { // 授权失败
    //       console.log('获取openId失败')
    //     }
    //   })
    // }
  }
}
Vue.prototype.StringUtil = StringUtil
Vue.prototype.filePath = 'https://cloud.wisewater.cn/'

export default {

}
